module.exports = __webpack_public_path__ + "cert_1.jpg?4db0997be22f3a964885ecb2177c0e29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert_1.jpg
// module id = 31
// module chunks = 0